import { useState } from "react";
import PropTypes from "prop-types";
import { Card, Dropdown, Button } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import { useLoader } from "@/hooks/LoaderProvider";
import UserDialog from "@/components/shared/dialogs/User_Dialog/Index";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";

const AttendeeCard = ({ attendee, onClose }) => {
  const { showLoader, hideLoader } = useLoader();
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleOpenDialog = () => {
    showLoader();
    setTimeout(() => {
      hideLoader();
      setIsDialogVisible(true);
      onClose();
    }, 1000);
  };

  const handleMenuClick = ({ key }) => {
    if (key === "message" || key === "block") {
      handleOpenDialog();
    }
  };

  return (
    <>
      <Card className="w-full shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 overflow-hidden">
            <Avatar
              src={attendee.avatar}
              size="large"
              shape="circle"
              className="flex-shrink-0"
            />
            <span className="font-medium text-darkGrey text-sm sm:text-base whitespace-nowrap overflow-hidden text-ellipsis">
              {attendee.name}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Button
              type="primary"
              className="min-w-[80px] px-2 h-8 text-xs sm:text-sm"
              style={{
                backgroundColor: "var(--veegil-color-lighter-blue)",
                color: "var(--veegil-color-primary)",
                border: "none",
              }}>
              {attendee.confirmed ? "Confirmed" : "Confirm"}
            </Button>
            <Dropdown
              menu={{
                items: [
                  {
                    key: "message",
                    label: "Message User",
                  },
                  {
                    key: "block",
                    label: "Block this user",
                    danger: true,
                  },
                ],
                onClick: (e) => handleMenuClick(e),
              }}
              placement="bottomRight"
              trigger={["click"]}>
              <CustomMoreOptions
                variant="filled"
                onClick={(e) => e.stopPropagation()}
                color="black"
                orientation="vertical"
                size="small"
              />
            </Dropdown>
          </div>
        </div>
      </Card>

      <UserDialog
        isVisible={isDialogVisible}
        onClose={() => setIsDialogVisible(false)}
        user={attendee}
      />
    </>
  );
};

AttendeeCard.propTypes = {
  attendee: PropTypes.shape({
    id: PropTypes.number,  
    name: PropTypes.string,
    avatar: PropTypes.string,
    confirmed: PropTypes.bool,
    username: PropTypes.string,
  }),
  onClose: PropTypes.func,
};

export default AttendeeCard;
